import styled from "styled-components";

export const StyledJobImagesPage = styled.div``;